import { createReducer, on } from '@ngrx/store';
import { loadForm, saveForm, updateForm } from './formInscription.actions';

export interface FormState {
    formInscription:{
        data:{}
    }
}

export const initialFormState: FormState = {
    formInscription:{
        data: {}
    }
};

export const formInscriptionReducer = createReducer(
    initialFormState,

    on(loadForm, (state) => ({ ...state, loading: true })),

    on(saveForm, (state) => ({ ...state, loading: true })),

    on(updateForm, (state, data) => ({
        ...state,
        data
    }))
);